export const sponsorsData = [
  {
    name: 'NTT DATA',
    logo: '/images/sponsors/nttdata.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/nttdata',
    tier: 'diamond',
    description: `NTT DATA is a $30+ billion trusted global innovator of business and technology services. We serve 75% of the Fortune Global 100 and are committed to helping clients innovate, optimize and transform for long-term success. We invest over $3.6 billion each year in R&D to help organizations and society move confidently and sustainably into the digital future. As a Global Top Employer, we have diverse experts in more than 50 countries and a robust partner ecosystem of established and start-up companies. Our services include business and technology consulting, data and artificial intelligence, industry solutions, as well as the development, implementation and management of applications, infrastructure, and connectivity. We are also one of the leading providers of digital and AI infrastructure in the world. NTT DATA is part of NTT Group and headquartered in Tokyo. Visit us at https://us.nttdata.com/en/.`,
    linkedin: 'https://www.linkedin.com/company/ntt-data-americas/',
    twitter: 'https://x.com/NTT_DATA_NA',
    instagram: 'https://www.instagram.com/nttdataplus/',
    youtube: 'https://www.youtube.com/@nttdatanorthamerica',
    blogs: [
      {
        title: 'NTT DATA: A blend of leadership, culture and creativity',
        url: 'https://us.nttdata.com/en/blog/2024/april/a-blend-of-leadership-culture-and-creativity',
        date: 'April 18, 2024'
      },
      {
        title: 'A journey of opportunities and growth',
        url: 'https://us.nttdata.com/en/blog/2024/january/a-journey-of-opportunities-and-growth',
        date: 'January 24, 2024'
      },
      {
        title: 'A dive into personal growth and culture at NTT DATA',
        url: 'https://us.nttdata.com/en/blog/2023/november/a-dive-into-personal-growth-and-culture-at-ntt-data',
        date: 'November 07, 2023'
      },
      {
        title: 'Upward leap: Growing through enriching experiences at NTT DATA',
        url: 'https://us.nttdata.com/en/blog/2023/october/growing-through-enriching-experiences-at-ntt-data',
        date: 'October 09, 2023'
      },
      {
        title: 'NTT DATA Embraces Differences, Promotes Fairness',
        url: 'https://us.nttdata.com/en/blog/2023/june/ntt-data-embraces-differences',
        date: 'June 08, 2023'
      },
      {
        title: 'The Journey to Success: Rising Through the Ranks at NTT DATA',
        url: 'https://us.nttdata.com/en/blog/2023/april/rising-through-the-ranks-at-ntt-data',
        date: 'April 20, 2023'
      },
      {
        title: 'Taking Your Career to the Next Level at NTT DATA',
        url: 'https://us.nttdata.com/en/blog/2023/february/taking-your-career-to-the-next-level-at-ntt-data',
        date: 'February 07, 2023'
      }
    ]
  },
  {
    name: 'Salesforce',
    logo: '/images/sponsors/salesforce.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/salesforce',
    tier: 'diamond',
    description: `Salesforce is the world’s #1 customer relationship management (CRM) platform. We help your marketing, sales, commerce, service and IT teams work as one from anywhere — so you can keep your customers happy everywhere. Learn more at https://www.salesforce.com/`,
    linkedin: 'https://www.linkedin.com/company/salesforce/',
    twitter: 'https://twitter.com/salesforce',
          blogs: [
            { title: 'Five Ways of Dealing with Change Fatigue in Digital Transformation', url: 'https://www.criticalriver.com/chin-up-five-ways-of-dealing-with-change-fatigue-in-digital-transformation/' },
            { title: 'Top Real Estate Firm’s Email Automation with Cloud Data Integration', url: 'https://www.criticalriver.com/case-study-real-estate-email-automation-with-cloud-data-integration/' },
            { title: 'Pushing Beyond the Initial Hype: How Organizations Can Create Value with Generative AI?', url: 'https://www.criticalriver.com/pushing-beyond-the-initial-hype-how-organizations-can-create-value-with-generative-ai/' }
          ],
    instagram: 'https://www.instagram.com/salesforce/',
    youtube: 'https://www.youtube.com/user/salesforce' 
  },
  {
    name: 'Provar',
    logo: '/images/sponsors/provar.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/provar',
    tier: 'silver',
    description: `Provar offers solutions to support you on your expedition to quality. We provide integrated quality management, maintainable test automation, release governance, and outstanding support to teams using complex systems like Salesforce. Our suite of low-code products improve release agility, reduce system defects, and advance innovation. Visit us at https://provar.com/.`,
    linkedin: 'https://www.linkedin.com/company/provar-testing',
    twitter: 'https://twitter.com/ProvarTesting',
    instagram: '',
    youtube: 'https://www.youtube.com/c/ProvarTesting',
      blogs: [
        {
          title: 'The Top 5 Reasons to Choose Provar for Automated Testing',
          url: 'https://provar.com/blog/product/top-5-reasons-choose-provar-automated-testing/',
          date: 'May 9, 2024'
        },
        {
          title: 'Salesforce Testing 101: Why Test and Where to Start?',
          url: 'https://provar.com/blog/thought-leadership/salesforce-testing-101-why-test-where-to-start/',
          date: 'January 16, 2024'
        },
        {
          title: 'How Does Provar Automation Stack Up to Tools Using Robotic Capabilities?',
          url: 'https://provar.com/blog/thought-leadership/how-does-provar-automation-stack-up-to-tools-using-robotic-capabilities/',
          date: 'January 9, 2024'
        },
        {
          title: 'How to Pick Your Salesforce Consulting Partner',
          url: 'https://bengalurudreamin.com/how-to-pick-your-salesforce-consulting-partner/',
          date: 'January 16, 2024'
        }
      ]
  },
  {
    name: 'CriticalRiver',
          blogs: [
            { title: 'A Comprehensive Guide to Salesforce CTI Integration', url: 'https://360smsapp.com/blog/a-comprehensive-guide-to-salesforce-cti-integration/', date: 'March 20, 2024' }
          ],
    logo: '/images/sponsors/criticalriver.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/criticalriver',
    tier: 'silver',
    description: `CriticalRiver Inc. is a globally recognized consulting and technology services provider that redefines the boundaries of digital transformation. Specializing in delivering innovative solutions, CriticalRiver Inc. provides unparalleled technology consulting services to address the complex business challenges of its clients, including the world's leading enterprises and Fortune 100 and 500 companies. Visit us at: https://www.criticalriver.com<br/><br/>The company through stock options:<br/>This initiative ensures that every team member shares in the company's success, fostering a culture of commitment, innovation, and shared prosperity.<br/>Commenting on the milestone, Mr. Anji Maram, Founder & CEO of CriticalRiver Inc., said, "This strategic move is more than a milestone; it's a testament to our confidence in our team and our collective future. Aligning with our visionary goal, we are setting the stage for propelling CriticalRiver towards revenues of $500 million by 2030 and achieving our Initial Public Offering (IPO) vision thereafter. The ESOP further reinforces our commitment to innovation and excellence, ensuring unwavering customer confidence. This strategic shift underscores our unwavering commitment to bolstering client confidence, and we're further reinforcing the founders' and management's steadfast dedication to nurturing the organization's growth."`,
    linkedin: 'https://in.linkedin.com/company/criticalriver',
    twitter: 'https://twitter.com/CriticalRiver',
    instagram: '',
    youtube: ''
  },
  {
    name: 'UST',
          blogs: [
            { title: 'Testsigma Salesforce Testing Launch', url: 'https://testsigma.com/blog/testsigma-salesforce-testing-launch/' },
            { title: 'Salesforce Testing Low Code Platform', url: 'https://testsigma.com/blog/salesforce-testing-low-code-platform/' },
            { title: 'Simplify Your Salesforce Testing With Testsigma', url: 'https://docs.google.com/document/d/1QInFNvSOM5v2fTaNNePBKdyBVNZo2stsz-O8_t-ojbc/edit' }
          ],
    logo: '/images/sponsors/ust.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/ust',
    tier: 'silver',
    description: `UST has partnered with Salesforce since 2003, serving Fortune 500 companies. We are an SFDC Crest Consulting Partner, Ridge ISV Partner, MuleSoft Partner, and Salesforce Talent Alliance member with a 4.9/5 CSAT rating on Salesforce AppExchange. With Expert Level Navigator status in Customer 360, the UST Salesforce Practice team excels in Experience, Knowledge, and Quality of Salesforce implementations. Visit us at https://www.ust.com/en/ust-and-salesforce`,
    linkedin: 'https://www.linkedin.com/company/ustglobal',
    twitter: 'https://x.com/ustglobal',
    instagram: 'https://www.instagram.com/ust.global/',
    youtube: 'https://www.youtube.com/c/USTGlobal'
  },
  {
    name: 'Cloud',
          blogs: [
            { title: "LET'S BUILD THE FUTURE OF YOUR CUSTOMER RELATIONSHIP.", url: 'https://www.springfive.com/en/let-s-build-the-future-of-your-customer-relationship' }
          ],
    logo: '/images/sponsors/360DegreeCloud.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/360-degree-cloud-technologies',
    tier: 'bronze',
    description: `360 Degree Cloud Technologies is a leading provider of Salesforce solutions, specializing in delivering innovative and customized services to help businesses achieve their digital transformation goals. With a team of certified Salesforce experts, we offer a wide range of services, including Salesforce implementation, customization, integration, and support. Our mission is to empower organizations to leverage the full potential of Salesforce and drive business success. Visit us at https://www.360degreecloud.com.`,
    linkedin: 'https://in.linkedin.com/company/360-degree-cloud',
    twitter: 'https://twitter.com/360degreecloud',
    instagram: 'https://www.instagram.com/360_degreecloud/',
    youtube: ''
  },
  {
    name: 'AEKOT',
    logo: '/images/sponsors/aekot.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/aekot',
    tier: 'bronze',
    description: `Aekot is a leading provider of Salesforce solutions, specializing in delivering innovative and customized services to help businesses achieve their digital transformation goals. With a team of certified Salesforce experts, we offer a wide range of services, including Salesforce implementation, customization, integration, and support. Our mission is to empower organizations to leverage the full potential of Salesforce and drive business success. Visit us at https://www.aekot.com.`,
    linkedin: 'https://www.linkedin.com/company/aekot',
    twitter: 'https://twitter.com/aekot',
    instagram: '',
    youtube: ''
  },
  {
    name: 'blue5green',
    logo: '/images/sponsors/blue5green.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/blue5green',
    tier: 'bronze',
    description: `blue5green is a leading provider of Salesforce solutions, specializing in delivering innovative and customized services to help businesses achieve their digital transformation goals. With a team of certified Salesforce experts, we offer a wide range of services, including Salesforce implementation, customization, integration, and support. Our mission is to empower organizations to leverage the full potential of Salesforce and drive business success. Visit us at https://www.blue5green.com.`,
    linkedin: 'https://www.linkedin.com/company/blue5green',
    twitter: 'https://twitter.com/blue5green',
    instagram: '',
    youtube: ''
  },
  {
    name: 'Testsigma',
    logo: '/images/sponsors/testsigma.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/testsigma',
    tier: 'silver',
    description: `TestSigma is a leading provider of Salesforce solutions, specializing in delivering innovative and customized services to help businesses achieve their digital transformation goals. With a team of certified Salesforce experts, we offer a wide range of services, including Salesforce implementation, customization, integration, and support. Our mission is to empower organizations to leverage the full potential of Salesforce and drive business success. Visit us at https://www.testsigma.com.`,
    linkedin: 'https://www.linkedin.com/company/testsigma',
    twitter: 'https://twitter.com/testsigma',
    instagram: '',
    youtube: 'https://www.youtube.com/c/TestSigma'
  },
  {
    name: 'SpringFive',
    logo: '/images/sponsors/springfive.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/springfive',
    tier: 'bronze',
    description: `SpringFive is a leading provider of Salesforce solutions, specializing in delivering innovative and customized services to help businesses achieve their digital transformation goals. With a team of certified Salesforce experts, we offer a wide range of services, including Salesforce implementation, customization, integration, and support. Our mission is to empower organizations to leverage the full potential of Salesforce and drive business success. Visit us at https://www.springfive.com.`,
    linkedin: 'https://www.linkedin.com/company/springfive',
    twitter: 'https://twitter.com/springfive',
    instagram: '',
    youtube: ''
  },
  {
    name: 'Appstrail',
    logo: '/images/sponsors/appstrail.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/appstrail',
    tier: 'associate',
    description: 'Appstrail is an associate sponsor.',
    linkedin: '',
    twitter: '',
    instagram: '',
    youtube: ''
  },
  {
    name: 'Winfomi',
    logo: '/images/sponsors/winfomi.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/winfomi',
    tier: 'associate',
    description: 'Winfomi is an associate sponsor.',
    linkedin: '',
    twitter: '',
    instagram: '',
    youtube: ''
  },
  {
    name: 'Ethnus',
    logo: '/images/sponsors/ethnus.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/ethnus',
    tier: 'associate',
    description: 'Ethnus is an associate sponsor.',
    linkedin: '',
    twitter: '',
    instagram: '',
    youtube: ''
  },
  {
    name: 'Brisk Minds',
    logo: '/images/sponsors/briskminds.png',
    url: '/BengaluruDreamin2025/event-founders/sponsors/briskminds',
    tier: 'associate',
    description: 'Brisk Minds is an associate sponsor.',
    linkedin: '',
    twitter: '',
    instagram: '',
    youtube: ''
  }
];